module.exports = __webpack_public_path__ + "img/strick-icon.58b83f63.svg";